export default {
  documentTitle: 'Back-end d\'administration',
  id: 'ID',
  createdAt: 'Créé à',
  updatedAt: "Mis à jour à",
  new: 'Créé',
  detail: 'Détail',
  edit: 'Modifier',
  destroy: 'Supprimer',
  operateSuccess: 'Opération réussie',
  approveAndSentSuccess: 'Approuvé, et envoi du code de référence réussi',
  testerTitleInListPage: 'Expérimentateurs (afficher uniquement ceux ajoutés par cette plate-forme)',
  suggestSize: 'Taille suggérée',
  createApplication: 'Nouvelle application',
  logout: "Quitter",
  chooseRole: 'Choisir un rôle',
  miniProgram: 'MiniProgramme',
  waitForBinding: 'Waiting to be bound',
  waitForWechatAudit: "La demande d'inscription au miniProgramme a été soumise, en attente de l'audit WeChat",
  miniProgramRegistrationFail: "L'enregistrement de l'applet a échoué, cliquez pour voir",
  yesterdayPageView: "Pages consultées hier",
  yesterdayUserView: "Visiteurs d'hier",
  customPlan: "Package",
  standardPlan: "Standard",
  expired: "Expiré",
  expiredTime: "Expire à",
  expiredTips: "L'applet du forfait expiré sera dans un état fermé, vous ne pourrez pas accéder à l'applet. Veuillez contacter le service clientèle pour une mise à niveau ou un renouvellement.",
  contactCustomer: 'Contacter le service client',
  customerPhone: 'Numéro de téléphone du service clientèle',
  customerEmail: "Adresse électronique du service clientèle",
  longTermEffective: 'Efficacité à long terme',
  visitsInTheLastWeek: "Visites au cours de la dernière semaine",
  pageView: 'Vues',
  userView: "Nombre de visiteurs",
  noData: "Aucune donnée disponible",
  newUserStatistics: 'Statistiques sur les nouveaux utilisateurs',
  usersCount: "Nombre d'utilisateurs",
  membersCount: 'Nombre de membres',
  userGenderDistribution: 'Distribution des sexes des utilisateurs',
  userGender: "Sexe de l'utilisateur",
  userTypeDistribution: "Distribution du type d'utilisateur",
  userType: "Type d'utilisateur",
  notAssociatedApplication: "Aucune application n'est associée au compte courant",
  changePassword: "Modifier le mot de passe",
  currentPassword: "Mot de passe actuel",
  newPassword: "Nouveau mot de passe",
  confirmPassword: "Confirmer le mot de passe",
  error: 'Erreur',
  pleaseLogin: "Veuillez vous connecter",
  verificationCodeSendSuccessfully: 'Le code de vérification a été envoyé avec succès',
  productsCount: 'Nombre de vins',
  postsCount: 'Nombre de messages',
  messagesCount: "Nombre de demandes de renseignements",
  unreadMessagesCount: "Nombre de messages non lus",
  count: 'Nombre',
  unauthorized: 'Pas encore autorisé',
  unlockWallet: 'Déverrouiller le portefeuille',
  resetPassword: 'Réinitialiser le code PIN',
  resetPasswordSuccess: 'Opération réussie. Le code PIN temporaire a été envoyé à l\'utilisateur.',
  exportTicketsQrcode: 'Exporter le code QR du billet',
  exporting: 'Le fichier est en cours d\'exportation et il sera envoyé à la boîte aux lettres une fois l\'exportation réussie',
  show: 'Afficher',
  hide: 'Cacher',
  download: 'Télécharger',
  resolve: 'Résoudre',
  suspended: 'Suspendu',
  before: 'avant',
  after: 'après',
  sendReward: 'Envoyer une récompense',
  // 将英文翻译成法语
  bean: {
    actionNew: 'Créer',
    actionExport: 'Exporter',
    actionImport: 'Importer',
    actionEdit: 'Modifier',
    actionDetail: 'Détail',
    actionSubmit: 'Soumettre',
    actionFilter: 'Filtrer',
    actionReset: 'Réinitialiser',
    actionConfirm: 'Confirmer',
    actionClose: 'Fermer',
    actionCancel: 'Annuler',
    actionAdd: 'Ajouter',
    actionExpand: 'Développer',
    actionCollapse: 'Réduire',
    actionUpload: 'Télécharger',
    actionDelete: 'Supprimer',
    actionQuery: 'Recherche',
    actionNavBack: 'Retour',
    actionOperation: 'Opération',
    actionChooseFile: 'Choisir le Fichier',
    actionChooseDirectory: 'Choisir le Répertoire',
    actionUploadAll: 'Tout Télécharger',
    actionRemoveAll: 'Tout Supprimer',
    actionSelectAll: 'Tout Sélectionner',
    actionRemove: 'Retirer',
    actionLogout: 'Se Déconnecter',
    actionTableToExcel: "Exporter vers Excel",
    deleteSuccess: 'Suppression réussie',
    createSuccess: 'Création réussie',
    updateSuccess: 'Mise à jour réussie',
    uploadSuccess: 'Téléchargement réussi',
    fieldRequired: '{field} requis',
    dragSort: 'Tri par glisser-déposer',
    imageResizer: 'Redimensionneur d\'image',
    resizeImage: 'Redimensionner l\'image',
    imageResized: 'Redimensionné',
    maximumFileSize: 'Taille maximale du fichier : {size}',
    maximumUploadFileCount: '{count} fichiers peuvent être téléchargés au maximum',
    filteredUploadFileTip: 'Fichiers filtrés qui ne répondent pas aux exigences',
    chooseBlobTagTip: 'Sélectionnez ou créez la balise. Balise à appliquer à toutes les images à télécharger',
    fileFormat: 'Format de fichier',
    folder: 'Dossier',
    fileName: 'Nom de fichier',
    fileSize: 'Taille de fichier',
    fileType: 'Type de fichier',
    tag: 'Balise',
    confirmDeleteTip: 'Supprimer ok ?',
    selectCountItem: 'Sélectionner {count} élément(s)',
    yes: 'Oui',
    no: 'Non',
    link: 'Lien',
    list: 'Liste',
    all: 'Tous',
    selected: 'sélectionné(s) : ',
    blankSelected: 'Sélection vide',
    noOptions: 'Il n\'y a pas d\'options',
    enterKeywordFiltering: 'Saisissez des mots-clés pour le filtrage',
    error_massage: 'message_erreur',
    importSuccess: 'Importation réussie',
    importFail: 'Échec de l\'importation. Veuillez vérifier le fichier "message_erreur.xlsx" pour plus de détails',
    formValidateError: 'Il y a une erreur dans la validation de l\'élément de formulaire',
    selectEvent: 'Sélectionner un événement',
    checksumPending: 'Vérification du fichier...',
    addNewOptionType: 'Nouveau type d\'option',
    optionTypes: 'Types d\'option',
    editVariant: 'Modifier la variante',
    chooseOptionType: 'Choisir le type d\'option',
    pleaseInputOptionTypeName: 'Veuillez saisir le nom du type d\'option',
    pleaseInputOptionValueName: 'Veuillez saisir la valeur de l\'option',
    pleaseInputNewOptionTypeName: 'Veuillez saisir un nouveau nom',
    pleaseInputNewOptionValueName: 'Veuillez saisir un nouveau nom',
    pageGenerator: {
      text: 'Texte',
      title: 'Titre',
      richText: 'Texte enrichi',
      image: 'Image',
      imageHotArea: 'Zone sensible de l\'image',
      multipleImage: 'Plusieurs images sur une ligne',
      video: 'Vidéo',
      swiper: 'Carrousel',
      splitLine: 'Ligne de séparation',
      blank: 'Vide',
      scrollX: 'Faire défiler horizontalement',
      map: 'Carte',
      navbar: 'Barre de navigation',
      form: 'Formulaire',
      popup: 'Fenêtre contextuelle',
      fixedButton: 'Bouton latéral fixe',
      zIndex: 'Niveau de rendu',
      zIndexBigOneOnTop: 'Les plus grands sont en haut',
      save: 'Enregistrer',
      hotArea: 'Zone sensible',
      shareTitle: 'Titre du partage',
      shareImage: 'Images partagées',
      posterBackgroundImage: 'Image d\'affiche',
      posterBackgroundColor: 'Couleur de fond de l\'affiche',
      posterText: 'Texte d\'affiche',
      posterTextColor: 'Couleur de texte d\'affiche',
      titleBackgroundColor: 'Couleur de fond de titre',
      titleColor: 'Couleur de titre',
      backgroundColor: 'Couleur de fond ',
      paddingTop: 'Marge supérieure',
      paddingBottom: 'Marge inférieure',
      paddingLeft: 'Marge gauche',
      paddingRight: 'Marge droite',
      white: 'Blanc',
      black: 'Noir',
      imageSize: 'Taille de l\'image {size}',
      pageSettings: 'Paramètres de la page',
      componentSettings: 'Paramètres du composant',
      baseSettings: 'Paramètres de base',
      styleSettings: 'Paramètres de style',
      eventSettings: 'Paramètres d\'événement',
      animationSettings: 'Paramètres d\'animation',
      moduleName: 'Nom du module',
      moduleNameTip: 'Il est utilisé uniquement pour le marquage et ne peut pas être rempli. Il n\'affecte pas le rendu de la page client',
      navigateType: 'Type de navigation',
      miniprogramPage: 'Page interne Mini-programme',
      externalMiniprogramPage: 'Autre page Mini-programme',
      webviewPage: 'Page WebView',
      selectPage: 'Sélectionner la page',
      selectComponent: 'Sélectionner le composant',
      webviewLink: 'Adresse Webview',
      externalMiniprogramPageAppid: 'Appid du mini-programme de navigation',
      externalMiniprogramPagePath: 'Chemin de page du mini-programme de navigation',
      address: 'Nom de l\'adresse',
      longitude: 'Longitude',
      latitude: 'Latitude',
      navigateToPage: 'Naviguer vers la page',
      makePhoneCall: 'Passer un appel',
      openMap: 'Ouvrir la carte pour voir l\'adresse',
      shareWithFriend: 'Partager avec des amis (déclencher les paramètres de partage de la page)',
      shareByPoster: 'Générer une affiche (déclencher la configuration de la page pour générer une affiche)',
      contact: 'Contacter le service client',
      previewImage: 'Aperçu de l\'image',
      phoneNumber: 'Numéro de téléphone',
      selectPopup: 'Sélectionner la fenêtre contextuelle',
      height: 'Hauteur',
      buttonPosition: 'Position du bouton',
      lateralDistance: 'Distance latérale',
      longitudinalDistance: 'Distance longitudinale',
      buttomImage: 'Image de bouton',
      buttonWidth: 'Largeur du bouton',
      buttonHeight: 'Hauteur du bouton',
      buttonZIndex: 'Niveau du bouton',
      buttonZIndexInfo: 'Boutons fixes multiples, le niveau élevé sera affiché au-dessus',
      rightBottom: 'En bas à droite',
      rightTop: 'En haut à droite',
      leftBottom: 'En bas à gauche',
      leftTop: 'En haut à gauche',
      distanceWithWindow: 'Distance fenêtre visuelle {position} distance',
      leftSide: 'Gauche',
      rightSide: 'Droite',
      topSide: 'Haut',
      bottomSide: 'Bas',
      formInputPlaceHolder: 'S\'il vous plaît entrez votre nom',
      formTelPlaceHolder: 'S\'il vous plaît entrer le numéro de contact',
      formEmailPlaceHolder: 'Entrez votre adresse e-mail',
      formContentPlaceHolder: 'Entrez le contenu',
      setting: 'Réglage',
      inputFontColor: 'Couleur de police de saisie',
      borderColor: 'Couleur de bordure',
      inputBorderRadius: 'Rayon de bordure de la boîte de saisie',
      fontSize: 'Taille du texte',
      fontColor: 'Couleur du texte',
      selectedStateColor: 'Couleur d\'état sélectionné',
      buttonFontSize: 'Taille de police du bouton',
      buttonFontColor: 'Couleur de police du bouton',
      buttonBackgroundColor: 'Couleur de fond du bouton',
      buttonBorderRadius: 'Rayon de bordure du bouton',
      selectImage: 'Sélectionner une image',
      relativeWithContainerWidth: 'Pourcentage par rapport à la largeur du conteneur',
      alignType: 'Alignement',
      alignLeft: 'Aligner à gauche',
      alignCenter: 'Alignement central',
      alignRight: 'Aligner à droite',
      imageList: 'Liste d\'images',
      imageSpacing: 'Espacement des images',
      verticalAlignment: 'Alignement vertical',
      alignTop: 'Aligner en haut',
      alignBottom: 'Justification en bas',
      navbarType: 'Style',
      'navbarType1': 'Style 1',
      'navbarType2': 'Style 2',
      navbarItems: 'Éléments de navigation',
      isSelected: 'Vérifier',
      popupName: 'Nom de la fenêtre contextuelle',
      popupAutoOpen: 'Fenêtre contextuelle automatique',
      popupShowTimes: 'Popup n fois',
      popupShowTimesTip: 'Sélectionnez "popup automatique" pour prendre effet',
      popupCloseButtonTriggerEvent: 'Événement de déclenchement du bouton de fermeture',
      popupCloseButtonTip: 'Cliquez sur le bouton \'X\' en bas pour déclencher \'Paramètres d\'événement\' ainsi que la \'fermeture de la fenêtre contextuelle\'',
      popupRenderHeight: 'Hauteur de l\'affichage',
      popupBorderRadius: 'Coins arrondis de la fenêtre contextuelle',
      textAlign: 'Alignement du texte',
      imageWidth: 'Largeur de l\'image',
      imageHeight: 'Hauteur de l\'image',
      titleFontSize: 'Taille de police du titre',
      titleTextColor: 'Couleur du titre',
      titleLineHeight: 'Hauteur de ligne du titre',
      subtitleFontSize: 'Taille du sous-titre',
      subtitleTextColor: 'Couleur du sous-titre',
      subtitleLineHeight: 'Hauteur de ligne du sous-titre',
      desTextFontSize: 'Taille de police de l\'introduction',
      desTextColor: 'Couleur de police de l\'introduction',
      desTextLineHeight: 'Hauteur de ligne de l\'introduction de sous-titre',
      lineColor: 'Couleur de la ligne',
      lineBorderWidth: 'Largeur de bordure de la ligne',
      lineType: 'Type de ligne',
      solid: 'Ligne solide',
      dashed: 'Ligne pointillée',
      dotted: 'Ligne en tiret',
      indicatorDots: 'Afficher les indicateurs de panneau',
      indicatorColor: 'Couleur de l\'indicateur',
      indicatorActiveColor: 'Couleur du point indicateur actuellement sélectionné',
      swiperAutoplay: 'Passage automatique',
      swiperInterval: 'Intervalle de passage automatique',
      swiperDuration: 'Durée de l\'animation de glissement',
      swiperCircular: 'Utiliser ou non le glissement de cohésion',
      noPreviewResult: 'Aucun aperçu disponible',
      addImage: 'Ajouter une image',
      sort: 'Trier',
      swiperTextBackgroundColor: 'Couleur de fond de la barre de texte',
      swiperTextPaddingTop: 'Marge supérieure de la barre de texte',
      swiperTextPaddingBottom: 'Marge inférieure de la barre de texte',
      swiperTextPaddingLeft: 'Marge gauche de la barre de texte',
      swiperTextPaddingRight: 'Marge droite de la barre de texte',
      lineHeight: 'Hauteur de ligne',
      color: 'Couleur',
      fontWeight: 'Poids du texte',
      fontWeightNormal: 'Par défaut',
      fontWeightBold: 'Gras',
      titleStyle: 'Style',
      'titleStyle1': 'Style 1',
      'titleStyle2': 'Style 2',
      titleStyleBackgroundColor: 'Couleur de style',
      uploadVideo: 'Télécharger une vidéo',
      videoPoster: 'Image de couverture de la vidéo',
      videoShowControls: 'Afficher les contrôles',
      videoAutoplay: 'Lecture automatique',
      videoLoop: 'Lecture en boucle',
      videoMuted: 'Muet',
      objectFit: 'Forme d\'affichage',
      contain: 'Contenir',
      fill: 'Remplir',
      cover: 'Couvrir',
      animationType: 'Type d\'animation',
      fade: 'Fondu enchaîné',
      scaleUp: 'Agrandir',
      scaleDown: 'Rétrécir',
      slideTop: 'Glisser vers le haut pour entrer',
      slideBottom: 'Glisser pour entrer',
      slideLeft: 'Glisser vers la gauche pour entrer',
      slideRight: 'Glisser vers la droite pour entrer',
      shake: 'Secouer',
      moveForward: 'Avancer',
      moveBack: 'Reculer',
      collapse: 'Effondrement',
      collapseItems: 'Articles',
      collapseContent: 'Contenu',
      collapseTitle: 'Titre',
      collapseIndicator: 'Icône d\'indicateur'
    },
  },
  dayOfWeek: {
    monday: 'Lundi',
    tuesday: 'Mardi',
    wednesday: 'Mercredi',
    thursday: 'Jeudi',
    friday: 'Vendredi',
    saturday: 'Samedi',
    sunday: 'Dimanche',
  },
  actions: {
    user: {
      isBlockToTrue: 'Suspendre',
      isBlockToFalse: 'Annuler la suspension',
      approve: 'Approuver',
      reject: 'Rejeter',
      unlockRedPacketFunction: 'Déverrouiller la fonction de saisie',
      lockWalkAccount: 'Suspendre les étapes',
      unlockWalkAccount: 'Annuler la suspension des étapes',
    }
  },
  login: {
    manageSystem: 'Gérer le système',
    remenberPassword: 'Se souvenir du mot de passe',
    forgetPassword: "Vous avez oublié votre mot de passe ?",
    login: "Connexion",
    loginSuccess: "Connexion réussie",
    inputEmail: 'Entrez l\'e-mail',
    inputPassword: "Entrez le mot de passe",
    confirmNewPassword: "Confirmer le mot de passe",
    inputRucaptcha: "Captcha d'entrée",
    resetPassword: "Réinitialiser le mot de passe",
    resetPasswordSuccess: 'Réinitialiser le mot de passe avec succès',
    sendVeirificationSuccess: 'Captcha envoyé',
    missingLoginName: 'E-mail requis',
    sendResetPasswordEmailSuccess: "L'email de réinitialisation du mot de passe a été envoyé",
    getResetPasswordEmail: "Obtenir l'e-mail de réinitialisation du mot de passe",
    signUp: "S'inscrire",
    sendVerificationCode: 'Envoyer',
    inputVerificationCode: 'Code d\'entrée',
    setPassword: "Définir le mot de passe",
    signIn: "Se connecter",
    signUpSuccess: "Enregistrement réussi",
  },
  wechatMiniProgram: {
    analysis: {
      refDate: 'temps',
      sessionCnt: "Nombre d'ouvertures",
      visitPv: "Nombre de visites",
      visitUv: "Nombre de visiteurs",
      visitUvNew: "Nombre de nouveaux utilisateurs",
      stayTimeUv: "Durée du séjour par personne (secondes)",
      stayTimeSession: "Durée moyenne du séjour (secondes)",
      visitDepth: "Profondeur moyenne des visites",
      retentionUvNew: "Nombre de nouveaux utilisateurs",
      retentionUvActive: "Nombre d'utilisateurs actifs",
      retainedUsers: "Nombre d'utilisateurs conservés",
      genderAndAge: "Sexe et âge",
      platformAndDevice: "Terminal et modèle",
      portraitOfNewUsers: "Nombre de nouveaux utilisateurs",
      portraitOfActiveUsers: "Nombre d'utilisateurs actifs",
      pagePath: 'Chemin de la page',
      pageVisitPv: "Nombre de visites",
      pageVisitUv: "Nombre de visiteurs",
      pageStaytimePv: "Durée moyenne de séjour",
      entrypagePv: "Nombre d'entrées sur la page",
      exitpagePv: "Nombre de sorties de la page",
      pageSharePv: "Nombre de redirections",
      pageShareUv: "Nombre de retweets",
      retainInfo: "Rétention des visites",
      userPortrait: "Portrait de l'utilisateur",
      accessSourceSessionCnt: "Source d'accès",
      accessStaytimeInfo: "Durée de l'accès",
      accessDepthInfo: "Profondeur d'accès moyenne",
      sourceAnalysis: "Analyse de la source",
      gender: "Sexe",
      age: "Age",
      region: "Distribution régionale",
      province: "Distribution provinciale",
      city: "Distribution locale",
      platform: "Terminal distribution",
      device: "Modèle de distribution",
      yesterday: "Hier",
      latest7Day: "Last 7 days",
      latest30Day: "Last 30 days",
      time: "Heure",
      daily: "Granularité quotidienne",
      weekly: "Granularité hebdomadaire",
      monthly: "granularité mensuelle",
      pleaseSelectDate: "Sélectionner la date",
      pleaseSelectWeek: 'Sélectionnez la semaine',
      pleaseSelectMonth: 'Sélectionnez le mois',
      weeklyFormat: 'yyyy WW week',
      timeDayLater: '%{value} days later',
      timeWeekLater: '%{value} semaines plus tard',
      timeMonthLater: '%{value} mois plus tard',
      visitDistribution: 'Visit source',
      summaryAndVisitPage: 'Pages visitées',
      visitTrend: 'Tendance des visites',
      visitPage: "Page visitée",
      visitRetain: "Rétention des visites",
    }
  },
  hint: {
    cannotChangeAfterCreate: 'Ne peut être modifié après la création',
    positionColumn: 'Plus la valeur est petite, plus la priorité est élevée',
    searchByPhone: 'Entrez le numéro de téléphone à rechercher',
    inputPhoneNumber: 'Saisir le numéro de téléphone',
    merchantCashbackPercentHint: '0 signifie aucun pourcentage de cashback',
    zeroMeansNoLimit: '0 signifie pas de limite',
    unlockRedPacketFunctionHint: 'L\'utilisateur opère trop fréquemment et a atteint aujourd\'hui la limite de recherche et de réception de grabs. Confirmer le déblocage afin que l\'utilisateur puisse continuer à rechercher et recevoir des grabs aujourd\'hui?',
    exportTicketsQrcodeSuccess: 'Exploiter le succès. L\'exportation prendra un certain temps. Veuillez actualiser la page plus tard pour afficher le lien de téléchargement du qrcode.',
    ticketNumberStartAtHint: 'Le numéro affiché sur le premier ticket lors de l\'exportation du qrcode du ticket. Les nombres générés ultérieurement seront automatiquement incrémentés de un.',
    turnOffSmsNotificationPlatformsHint: 'Après avoir sélectionné une plateforme, la plateforme ne recevra aucune autre notification à l\'exception du code de vérification SMS.',
    remainingAfterDeductingPendingWithdrawal: 'Restant après déduction du montant du retrait en attente',
    currentUserOrAgent: 'Utilisateur actuel ou compte de paiement',
    merchantNotActived: 'Le magasin ne dispose pas d\'un compte de paiement approuvé/activé et non suspendu et n\'apparaîtra pas dans l\'APP client',
    walkStepRecordIsActiveHint: 'Astuce: 1. Si l\'utilisateur se connecte à plusieurs appareils en utilisant le même compte, seul l\'appareil avec le plus grand nombre de pas dans la journée sera activé. 2. Si l\'utilisateur se connecte à plusieurs comptes sur le même appareil, seules les étapes de le premier compte de la journée sera actif.',
    walkChallengeParticipationRecordRankHint: 'Astuce: le classement est trié par étapes. Afin d\'éviter les classements ex æquo, si les étapes sont les mêmes, l\'utilisateur ayant participé en premier sera classé en premier. De cette façon, les récompenses peuvent être clairement distribuées en fonction des classements.',
    first_wallet_holder_of_the_same_device_hint: 'Compte précédemment utilisé sur cet appareil',
  },
  menu: {
    productManagement: "Gestion des vins",
    merchantManagement: "Gestion des vignobles",
    userManagement: "Gestion des utilisateurs",
    eventManagement: "Gestion des événements",
    pageManagement: "FAQ",
    applicationManagement: "Gestion des applications",
    contentManagement: "Gestion du contenu",
    homePage: "Accueil",
    dataAnalysis: "Statistiques",
    storeManagement: 'Gestion du magasin',
    placesListing: 'Liste des lieux',
    merchantCatalog: 'Catalogue',
    exploreSection: 'Section Explorer',
    userVerifications: 'Vérification',
    request: 'Demandes',
    smsPush: 'Poussée SMS',
    transactions: 'Transactions',
    allTransactions: 'Toutes les transactions',
    clientAppPush: 'Poussée de l\'application cliente',
    agentAppPush: 'Poussée vers l\'application marchande',
    notifications: 'Notifications',
    rulesAndKycs: 'Règles et KYCs',
    appVersionSettings: 'Paramètres de version',
    specificVerificationCodes: 'Codes de vérification spécifiques',
    newStoreOwner: 'Nouveau propriétaire du magasin',
    ledger: 'Registre',
    analytics: 'Analytique',
    masterLedger: 'Master ledger',
    liveEvents: 'Événements en direct',
    eventHistory: 'Historique des événements',
    createEvent: 'Créer un événement',
    addTickets: 'Ajouter des billets',
    loyaltyPrograms: 'Programmes de fidélité',
    grab: 'Grab',
    cashback: 'Cashback',
    redPacketSettings: 'Paramètres de saisie',
    walk: 'Marcher',
    electricity: 'Électricité',
    airtime: 'Temps d\'antenne',
    adSpace: 'Espace publicitaire',
    videoSpace: 'Espace vidéo',
    winners: 'Gagnants',
    redPacketJoga: 'Grab Joga',
  },
  model: {
    activeStorageBlob: 'Téléchargement de médias'
  },
  activeStorageBlob: {
    filename: 'Nom de fichier',
    contentType: 'Nom de fichierType de contenu',
    url: 'Contenu',
    contentTypes: {
      image: 'Image',
      video: 'Vidéo',
      audio: 'Audio',
      text: 'TeTextet',
      xml: 'XML',
      json: 'JSON',
      pdf: 'PDF',
      sheet: 'Feuille'
    }
  },
  customPage: {
    publish: 'publier',
    preview: 'Aperçu',
    default: "pages pré-remplies"
  },
  application: {
    miniProgram: 'Mini programme',
    shareDesc: "Description du partage",
    wechatOfficialAccountURL: "Lien public WeChat",
    homeTopLogo: "Logo anglais et chinois",
    homeBottomLeftLogo: "Logo anglais",
    questionaireTopImage: "Image au-dessus du titre du questionnaire",
    questionaireBackgroundImage: "Image de fond du questionnaire",
    personalCenterBackgroundImage: "Image d'arrière-plan du centre personnel",
    myCardsBackgroundImage: "Image d'arrière-plan de la carte de visite",
    wechatApplication: {
      trialSubmition: {
        userVersion: 'Experience Version',
        userDesc: "Description de la version d'essai",
        trialVersionQrcode: "Code QR de la version d'essai",
      },
      onlineSubmition: {
        userVersion: "Version en ligne",
        userDesc: 'Description de la version en ligne',
      },
      auditSubmition: {
        userVersion: 'Version de révision',
        userDesc: "Description de la version d'audit",
        state: "Statut de l'audit",
        reason: 'Raison',
      },
      qrcodeURL: "Version en ligne du code de l'applet",
    },
    actions: {
      submitAudit: "Soumettre un audit",
      simulateSubmitAudit: "Simuler un audit",
      release: 'Release',
      simulateRelease: "Simuler la libération",
      updateExpiredAt: "Définir le délai d'expiration",
      reauthorization: 'reauthorize',
      bindMiniProgram: 'bind applet',
    },
  },
  page: {
    presetPage: 'Pages préétablies',
  },
  banner: {
    targetUrl: "target link (lien cible)"
  },
  adminUser: {
    password: 'Mot de passe',
    passwordConfirmation: 'Confirmation du mot de passe'
  },
  plutus_entries: {
    commercial_document_kind: "Type de transaction",
    description: "Description",
    commercial_document_id: "ID des détails de la transaction",
    target_type: "Type de commerçant",
    target_id: "ID utilisateur/compte de paiement",
    month: 'Month : "Mois"',
    date_gteq: 'Date de transaction après',
    date_lteq: "Date de transaction avant",
    commercial_document: "Détail de la transaction",
    date: "Date",
    balance_remain_amount: 'Montant du solde restant',
    topup_amount_from_agent: "Montant de la recharge par l'agent",
    total_transaction_volumn: 'Volume total de la transaction',
    withdraw_amount: 'Montant du retrait',
    avatar: 'Avatar',
    first_name: 'Prénom',
    last_name: "Nom de famille",
    name: 'Nom',
    email: 'E-mail',
    phone: 'Téléphone',
    gender: 'Genre',
    whatsapp: 'Whatsapp',
    transaction_at: 'Transaction à',
    created_at: 'Créé à',
    updated_at: "Mis à jour à",
    number: "ID transaction",
    debitor_number: 'Téléphone du débiteur',
    creditor_number: 'Téléphone du créancier',
    profile_attributes: 'Profil',
    creditor_type: "Type de créancier",
    debitor_type: "Type de débiteur",
    kind: "Type",
    state: 'Etat',
    creditor_miapay_wallet_holder: 'Portefeuille du créancier',
    debitor_miapay_wallet_holder: "Titulaire du portefeuille du débiteur",
    amount_cents: 'Montant (FCFA)',
    cashback_amount_cents: 'Pièces (MPC)',
    user: 'Utilisateur',
    agent: "Compte de paiement",
    remark: 'Remarque',
    user_or_agent_phone: 'Téléphone de l\'utilisateur/compte de paiement',
    commercial_document_kind_map: {
      topup: 'Topup',
      withdraw: "Withdraw",
      transfer: "Transfer",
      pay_with_qr_code: "Payer avec un code QR",
      cashback: 'Remise en argent',
      create_red_packet: 'Créer une prise',
      receive_red_packet: 'Recevoir saisir',
      red_packet_expire: 'Saisir expirer',
      order_ticket: 'Commander un ticket',
      electricity: 'Électricité',
      airtime: 'Temps d\'antenne',
    }
  },
  sms: {
    allUsers: 'Tous les utilisateurs',
    allAgents: 'Tous les agents',
    phones: 'Téléphone',
    enMessage: 'Message en anglais',
    frMessage: 'Message en français',
    messageHint: 'Les variables intégrées entre crochets sont : %{variables}. Elles seront remplacées par le contenu réel avant l\'envoi.'
  },
  setting: {
    customerServicePhone: 'Téléphone du service client',
    customerServiceWhatsapp: 'Whatsapp du service client',
    customerServicseEmail: 'Courriel du service client',
    internalTestAccountPhones: 'Numéro de téléphone du compte de test interne',
    internalTestAccountPhonesHint: 'Pour faciliter les tests, ces comptes ne nécessitent pas de paiement réel et les transactions peuvent être effectuées directement',
    cashbackRules: 'Règles de remboursement (FCFA)',
    signUp: 'S\'inscrire',
    firstPayment: 'Premier paiement',
    firstTopup: 'Première recharge',
    loginPerDay: 'Connexion quotidienne / Une fois par jour',
    transfer: 'Transfert',
    paymentToMerchants: 'PPaiement aux commerçants',
    topupFromMobileMoney: 'Rechargement depuis l\'argent mobile',
    bindInvitor: 'Scannez le code QR pour lier l\'invité',
    invitedPerUser: 'Invité par utilisateur',
    paymentToMerchantsHint: 'Paiement aux commerçants si aucune offre n\'existe sur la plateforme',
    kycRules: 'Règles KYC (FCFA)',
    monthlyTransactionLimit: 'Limite mensuelle de transaction',
    dailyTransactionLimit: 'Limite quotidienne de transaction',
    walletBalanceLimit: 'Limite du solde du portefeuille',
    maxAmountPerRedPacket: 'Quantité maximale de par benne créée',
    dailyRedPacketCreatedCountLimit: 'Nombre maximum de prises pouvant être créées par jour',
    dailyRedPacketCreatedAmountLimit: 'Montant maximum de prises pouvant être créées par jour',
    clientAppVersions: 'Versions de l\'application client',
    agentAppVersions: 'Versions de l\'application Agent',
    smsProvider: 'Fournisseur de SMS',
    ticketEventPoster: 'Affiche de l\'événement du ticket',
    recommendedTicketEvent: 'Événement de ticket recommandé',
    explorePoster: 'Affiche de la section Explorer',
    appVersions: {
      version: 'Version',
      buildID: 'Build ID',
      force: 'Forcer',
      link: 'Lien',
    },
    appClient: 'Plateforme',
    appClients: {
      Client: 'MiaPay',
      Agent: 'MiaPay Collect',
    },
    phone: 'Téléphone',
    code: 'Code spécifique',
    codeHint: 'Veuillez entrer 4 chiffres',
    enabled: 'Activé',
    turnOffSmsNotificationPlatforms: 'Désactiver les notifications SMS',
    minimumTransactionAmounts: 'Montant minimum de transaction',
    topup: 'Rechargement',
    payWithQrCode: 'Payer avec un code QR',
    withdraw: 'Retrait',
    transferAmountMultiple: 'Le montant du transfert/paiement avec le code QR doit être un multiple de',
    explorePageRedPackageCode: 'Explorer la capture de page',
    jogaRedPackageCode: 'Joga saisir',
    showWithdrawalFunctionSuspendedPopup: 'Afficher la fenêtre contextuelle de suspension de la fonction de retrait',
  },
  withdrawalApplication: {
    miapayAccountNumber: 'Numéro de compte Miapay',
    paymentAccountNumber: 'Numéro de compte de paiement',
    userName: 'Nom d\'utilisateur',
  },
  merchant: {
    removeFromPlacesSection: 'Supprimer de la liste des lieux',
    addToPlacesSection: 'Ajouter à la liste des lieux',
    removeFromMerchantCatalog: 'Supprimer du catalogue',
    addToMerchantCatalog: 'Ajouter au catalogue',
    removeFromExploreSection: 'Supprimer de la section Explorer',
    addToExploreSection: 'Ajouter à la section Explorer',
    qrCode: 'QR Code'
  },
  redPacket: {
    manuallyReturn: 'Retour manuel expiré',
    customListItem: 'Espace publicitaire',
    types: {
      "RedPacket::Brand": "Marque",
      "RedPacket::Normal": "Normal",
      "RedPacket::Joga": "Joga",
    }
  },
  homePage: {
    userCount: 'Nombre d\'utilisateurs',
    newUserTrend: 'Nouvelle tendance des utilisateurs',
    newUserCount: 'Nouveau nombre d\'utilisateurs',
    newActivedUserCount: 'Nouveau nombre d\'utilisateurs actifs',
    newAdminUserCount: 'Nouveau nombre d\'utilisateurs administrateurs',
    activedUserCount: 'Nombre d\'utilisateurs actifs',
    agentCount: 'Nombre d\'agents',
    activedAgentCount: 'Nombre d\'agents actifs',
    newAgentTrend: 'Nouvelle tendance des agents',
    newAgentCount: 'Nouveau nombre d\'agents',
    newActivedAgentCount: 'Nouveau nombre d\'agents actifs',
    newTransactionsTrend: 'Nouvelle tendance des transactions',
    newTransactionsCount: 'Nouveau nombre de transactions',
    pendingStoreOwner: 'Propriétaire du magasin en attente',
    pendingUserVerification: 'En attente de vérification de l\'utilisateur',
    pendingMerchantWithdrawalRequest: 'Demande de retrait du commerçant en attente'
  },
  adminUsersRole: {
    refCodeRequestedEmail: 'Email de notification de demande de code de référence',
    withdrawalApplicationRequestedEmail: 'Email de notification de demande de retrait',
    feedbackAddedEmail: 'Email de notification de commentaire ajouté',
    walletAddedEmail: 'Email de notification de portefeuille ajouté',
    walletRemovedEmail: 'Email de notification de portefeuille supprimé',
    userVerifiedEmail: 'Email de notification de vérification d\'utilisateur',
  },
  storeOwner: {
    agentStatus: 'État du compte',
  },
  masterLedger: {
    total_amount_in_ledger: 'Montant total dans le registre',
    total_amount_in_agent_wallets: 'Montant total dans les portefeuilles des agents',
    total_amount_in_client_wallets: 'Montant total dans les portefeuilles des clients',
    total_number_of_agent_wallets_created: 'Nombre total de portefeuilles d\'agents créés',
    total_number_of_client_wallets_created: 'Nombre total de portefeuilles de clients créés',
    total_number_of_actived_agent_wallets: 'Nombre total de portefeuilles d\'agents actifs',
    total_number_of_actived_user_wallets: 'Nombre total de portefeuilles d\'utilisateurs actifs',
    total_amount_of_cashback_given: 'Montant total de remboursement donné',
    cashback_amount_trend: 'Tendance du montant de remboursement',
    total_number_of_transactions: 'Nombre total de transactions',
    average_transactions: 'Transactions moyennes',
  },
  user: {
    agentVerifier: 'Agente',
    isDeleted: 'Supprimé',
  },
  ticketAnalysics: {
    totalTicketSolds: 'Nombre total de billets vendus',
    revenue: 'Revenu (FCFA)',
    checkedIn: 'Enregistré',
    revenueByTicketType: 'Revenu par type de billet',
  },
  customListItem: {
    image: 'Image',
    video: 'Vidéo',
    videoCover: 'Couverture vidéo',
    externalLink: 'Lien externe',
    target: 'Lien cible',
    targetType: 'Type de lien',
  },
  walkAnalysics: {
    totalWalkersCount: 'Nombre total de marcheurs',
    thisMonthActiveWalkersCount: 'Actifs ce mois-ci',
    lastHourActiveWalkersCount: 'Actifs dans la dernière heure',
    totalKilometersDistance: 'Distance totale (km)',
    walkJoinedAt: 'Commencé le',
    walkLastActiveAt: 'Dernière activité le',
    newJoinedCount: 'Nombre de nouveaux rejoint',
    ActivedWakerCount: 'Nombre actif',
  },
  challengeAnalysics: {
    joinedCount: 'Nombre de participants',
    activeCount: 'Nombre actif',
    completedCount: 'Nombre terminé',
    incompleteCount: 'Nombre incomplet',
    winnersCount: 'Nombre de gagnants',
  },
}
